import React, { useCallback, useContext, useEffect, useState } from 'react'
import UserContext from '../../contexts/UserContext'
import axios from 'axios';
import { useNavigate,useLocation } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';


const SupplierHome = () => {
  const {user,setUser} = useContext(UserContext);
  const [supItemReq,setSupItemReq] = useState([]);
  const { state } = useLocation();

  const suppliers = 
   {
    zones:[{
        zoneId: '2',
        zoneName: 'Adyar',
    
    items:[
        {
            itemName: 'Almond Usa',
            itemQty: '3',
            itemUnit: 'kg'
            
        },
        {
            itemName: 'Cashwe',
            itemQty: '3',
            itemUnit: 'kg'
        },
        {
            itemName: 'Oil',
            itemQty: '3',
            itemUnit: 'Ltr'
        }
    ]
    },
    {
        zoneId: '3',
        zoneName: 'RoyaPuram',
    
    items:[
        {
            itemName: 'Onion',
            itemQty: '3',
            itemUnit: 'kg'
            
        },
        {
            itemName: 'Potato',
            itemQty: '3',
            itemUnit: 'kg'
        },
        {
            itemName: 'Ghee',
            itemQty: '3',
            itemUnit: 'Ltr'
        }
    ]
    }
    
    ],
    
   }
  ;

  const navigate = useNavigate();

  const getSupplyItemRequest = async () => {
    // if((user?.role != "Admin" || user?.role != "Purchase")) navigate("/login");
    console.log("IN GETTING Supplier ", state)
    //${state.userData.user._id}
    await axios.get(`${process.env.REACT_APP_API_URI}/api/supplier/getRequests`,{withCredentials:true}).then((response)=>{
      console.log(response)
      if(response.data.success){
        console.log(response.data.data?.user);
        setSupItemReq(response?.data?.data);
      }
    })
  }  
  console.log(suppliers);
  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
      if(user){
        getSupplyItemRequest();
      }
    }
    startup();
  },[user])
  const design = (
    <>
        {
        supItemReq && supItemReq.length>0?
       
        supItemReq.map((request) => (
            // onClick={()=>navigate("zone",{state:zone})}
            request.items.map((item)=>(
            <div key={request._id} onClick={()=>navigate("supplyItem",{state:request})} className='flex flex-row justify-between bg-slate-50 rounded-md shadow-inherit mt-5 mx-3 p-3 border-2 border-cyan-900 '>
            {console.log(request.items)}
            <div>
                <h3>Zone {item.zone.id}</h3>
                <p>{item.zone.desc}</p>
            </div>
            <div>
                <h3>{item.item.name}</h3>
                <p>{item.status}</p>
            </div>
            <div>
                <p>Total Item Requests:</p>
                <h5>{request.items?.length}</h5>
            </div>
        </div>))
              
        ))
        :
        <div>
            <h6>No Items Request Found !</h6>
        </div>
        }
    </>
  )
  return design;
}

export default SupplierHome